/*
 * site-video
 **/

class SiteVideo extends HTMLElement {
  constructor() {
    super();
    this.observe();
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function (video) {
          const $video = video.target;
          if (video.isIntersecting) {
            if ($video.readyState === 4) {
              $video.play();
            } else {
              [].slice
                .call($video.querySelectorAll("source"))
                .forEach((source) => {
                  source.src = source.dataset.src;
                });
              $video.load();
            }
          } else {
            if (!$video.paused) {
              $video.pause();
            }
          }
        });
      });

      videoObserver.observe(this.querySelector("video"));
    }
  }
}

customElements.define("site-video", SiteVideo);

/*
 * site-image
 **/

class SiteImage extends HTMLElement {
  constructor() {
    super();
    this.observe();
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function (image) {
          const $image = image.target;
          if (image.isIntersecting) {
            $image.classList.add("active");
            imageObserver.unobserve($image);
          }
        });
      });

      imageObserver.observe(this.querySelector(".mediabox"));
    }
  }
}

customElements.define("site-image", SiteImage);

/*
 * Swiper Carousel
 */

class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.id = this.dataset.id;
    this.initCarousel(this.data);
    this.setupListeners();
  }

  setupListeners() {
    const pagers = this.querySelectorAll(".carousel-pager");
    const testimonialImages = this.querySelectorAll(".testimonials__image");
    const prev = this.querySelector(".carousel-prev");
    const next = this.querySelector(".carousel-next");

    if (prev) {
      prev.addEventListener("click", () => {
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      });
    }

    if (next) {
      next.addEventListener("click", () => {
        if (this.swiper) {
          this.swiper.slideNext();
        }
      });
    }

    Array.from(pagers).forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        this.swiper.slideTo(i);
      });
    });

    this.swiper.on("slideChange", () => {
      pagers.forEach((el) => el.classList.remove("active"));
      const nextPager = pagers[this.swiper.realIndex];
      if (nextPager) {
        nextPager.classList.add("active");
      }

      if (prev) {
        if (this.swiper.realIndex > 0) {
          prev.removeAttribute("disabled");
        } else {
          prev.setAttribute("disabled", "");
        }
      }

      if (next) {
        if (this.swiper.realIndex === pagers.length - 1) {
          next.setAttribute("disabled", "");
        } else {
          next.removeAttribute("disabled");
        }
      }

      testimonialImages.forEach((el) => el.classList.remove("active"));
      const nextTestimonial = testimonialImages[this.swiper.realIndex];
      if (nextTestimonial) {
        nextTestimonial.classList.add("active");
      }
    });
  }

  initCarousel(config = { slidesPerView: 3, spaceBetween: 20 }) {
    this.swiper = new Swiper(`#${this.id} .swiper`, config);
  }
}

customElements.define("swiper-carousel", SwiperCarousel);
